import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { RouteConstants } from '../../shared/constants/route-constants';
import { AppActions } from './app.actions';
import { ErrorToastService } from '../services/error-toast.service';
import { NotificationActions } from '../../features/notifications/state/notification.actions';
import { DeviceActions } from '../../features/devices/state/device.actions';
import { DeviceGroupActions } from '../../features/devices/state/device-groups/device-group.actions';
import { RuleActions } from '../../features/rules/state/rule.actions';
import { CisternActions } from '../../features/cisterns/state/cistern.actions';
import { ScenarioActions } from '../../features/scenarios/state/scenario.actions';
import { KillSwitchActions } from '../../features/dashboard/state/kill-switch.actions';
import { ActionLogActions } from '../../features/action-log/state/action-log.actions';

@Injectable()
export class AppEffects {
  private actions$ = inject(Actions);
  private router = inject(Router);
  private errorToastService = inject(ErrorToastService);

  public navigateToRuleWithId$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AppActions.public.navigateToRuleWithId),
        tap((props) => {
          this.router.navigate([RouteConstants.routeRule, props.id]).then();
        }),
      ),
    { dispatch: false },
  );

  public navigateToRules$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AppActions.public.navigateToRules),
        tap((_props) => {
          this.router.navigate([RouteConstants.routeRule]).then();
        }),
      ),
    { dispatch: false },
  );

  public showErrorToast$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          NotificationActions.private.loadNotificationsFailure,
          NotificationActions.private
            .loadNotificationsWithProvidedFiltersFailure,
          NotificationActions.private.markAsReadFailure,
          NotificationActions.private.markAllAsReadFailure,
          NotificationActions.private.deleteAllFailure,
          DeviceActions.private.loadDevicesFailure,
          DeviceActions.private.loadDevicesWithProvidedFiltersFailure,
          DeviceActions.private.loadAllDevicesByFiltersFailure,
          DeviceActions.private.loadNextOfAllFailure,
          DeviceActions.private.triggerDeviceActionFailure,
          DeviceActions.private.updateDeviceFailure,
          DeviceActions.private.loadDeviceByIdFailure,
          DeviceGroupActions.private.loadDeviceGroupsFailure,
          DeviceGroupActions.private.loadDeviceGroupsWithProvidedFiltersFailure,
          DeviceGroupActions.private.loadAllDeviceGroupsByFiltersFailure,
          DeviceGroupActions.private.loadNextOfAllFailure,
          DeviceGroupActions.private.triggerDeviceGroupActionFailure,
          DeviceGroupActions.private.loadDeviceGroupByIdFailure,
          DeviceGroupActions.private.createDeviceGroupFailure,
          DeviceGroupActions.private.updateDeviceGroupFailure,
          DeviceGroupActions.private.deleteDeviceGroupFailure,
          RuleActions.private.loadRulesFailure,
          RuleActions.private.createRuleFailure,
          RuleActions.private.updateRuleFailure,
          RuleActions.private.deleteRuleFailure,
          RuleActions.private.loadRuleFailure,
          RuleActions.private.updateIsActiveFailure,
          RuleActions.private.loadRulesWithProvidedFiltersFailure,
          RuleActions.private.loadAllRulesByFiltersFailure,
          RuleActions.private.loadNextOfAllFailure,
          CisternActions.private.loadCisternsFailure,
          CisternActions.private.loadCisternsWithProvidedFiltersFailure,
          CisternActions.private.loadAllCisternsByFiltersFailure,
          CisternActions.private.loadNextOfAllFailure,
          CisternActions.private.createCisternFailure,
          CisternActions.private.updateCisternFailure,
          CisternActions.private.deleteCisternFailure,
          ScenarioActions.private.loadScenariosFailure,
          ScenarioActions.private.loadScenarioHistoryFailure,
          ScenarioActions.private.runScenarioFailure,
          ScenarioActions.private.stopScenarioFailure,
          ActionLogActions.private.loadActionLogFailure,
          KillSwitchActions.private.loadKillSwitchFailure,
          KillSwitchActions.private.triggerKillSwitchFailure,
          KillSwitchActions.private.loadEmergencyStopFailure,
          KillSwitchActions.private.triggerEmergencyStopFailure,
        ),
        tap(({ error }) => {
          this.errorToastService.show(error?.status);
        }),
      ),
    { dispatch: false },
  );
}
